<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" *ngIf="scheduledTask$ | async as scheduledTask">
  <!-- TODO: need to migrate to central header component which derives from ng-component library(doesnt support leading icon yet).  -->
  <!-- <oneapp-header
    *ngIf="scheduledTask"
    [title]="scheduledTask.taskName"
    (buttonClick)="deleteScheduledTask(scheduledTask)"
    [deleteButtonConfig]="deleteButtonConfig"
  ></oneapp-header> -->
  <div *ngIf="scheduledTask" fxLayout="row" fxLayoutAlign="start center" class="header">
    <div class="custom_header_container">
      <span *ngIf="scheduledTask.recurring; then recurringTaskIcon; else scheduledTaskIcon"></span>
      <ng-template #scheduledTaskIcon>
        <fa-icon class="icon schedule_icon" [icon]="faCalendar"></fa-icon>
      </ng-template>
      <ng-template #recurringTaskIcon>
        <fa-icon class="icon schedule_icon" [icon]="faRepeat"></fa-icon>
      </ng-template>
      <span id="TaskTitle" class="title">{{ scheduledTask.taskName }}</span>
    </div>
    <div class="expand"></div>
    <div>
      <oneapp-button
        [action]="buttonAction.DELETE"
        (click)="deleteScheduledTask(scheduledTask)"
        [disabled]="loadingTask"
      >
      </oneapp-button>
    </div>
  </div>
  <div *ngIf="!scheduledTask || loadingTask" fxFill fxLayoutAlign="center center">
    <fa-icon
      class="icon loading_spinner"
      [icon]="faSpinnerThird"
      aria-label="loading spinner"
    ></fa-icon>
  </div>
  <div class="detail_data_container" *ngIf="scheduledTask" fxLayout="column">
    <div class="detail-general-data" fxLayout="column">
      <app-task-assignee-detail
        class="task_properties"
        #taskAssigneeDetail
        [assignees]="scheduledTask.assignedTo"
        [assigneeType]="scheduledTask.assignedToEmployeeOrEmployeegroup"
      ></app-task-assignee-detail>

      <div class="task_properties" fxLayout="row" fxLayoutAlign="start center">
        <span class="task_properties_title" i18n="workflow label@@workflow">Workflow</span>
        <a class="link" id="workflowLink" (click)="navigateToWorkflow(scheduledTask.workflowName)">
          {{ scheduledTask.workflowName }}</a
        >
      </div>
      <div class="task_properties" fxLayout="row" fxLayoutAlign="start center">
        <span *ngIf="scheduledTask.recurring; then startingFrom; else scheduledFor"></span>
        <ng-template #startingFrom>
          <span class="task_properties_title" i18n="Starting from@@startingFrom"
            >Starting from</span
          >
        </ng-template>
        <ng-template #scheduledFor>
          <span class="task_properties_title" i18n="scheduled at label@@scheduledAt"
            >Scheduled for</span
          >
        </ng-template>

        <span class="task_properties_value">{{
          customDateFormatService.formatDate(scheduledTask.scheduledAt)
        }}</span>
      </div>

      <div class="task_properties" fxLayout="row" fxLayoutAlign="start center">
        <span class="task_properties_title" i18n="Repeat label@@RepeatLabel">Repeat</span>

        <span
          *ngIf="scheduledTask.recurring"
          class="task_properties_value"
          style="width: fit-content"
        >
          {{ getRecurringConfigFromService(scheduledTask.recurring, scheduledTask.scheduledAt) }}
        </span>
        <span *ngIf="!scheduledTask.recurring" class="task_properties_value" i18n="Never@@never"
          >Never</span
        >
      </div>
      <app-attachments-display
        [attachments]="scheduledTask?.meta_data?.attachments"
      ></app-attachments-display>
      <ng-container
        *ngTemplateOutlet="taskAssigneeDetail.missingAssigneeNoticeBox ?? null"
      ></ng-container>
    </div>
  </div>
</div>
